import axios from "axios";
import { STRATEGY_TYPE } from "utils/constant/STATUS";
import * as Sentry from "@sentry/nextjs";


export const sessionUpdate = async ({ update }: { update: any }) => {
    let timer: NodeJS.Timeout;
    // timer 가 끝날 때까지 기다림 Promise
    await new Promise((resolve: any) => {
        timer = setTimeout(() => {
            update();
            resolve();
        }, 100);
        // clearTimeout(timer);
    });
};
export const handleStrategyAlarmClick = async ({
    session,
    update,
    router,
    isAlarmRegistered,
    sCode,
    setAlarmToastVisible,
    success,
    fail,
}: {
    session: any;
    update: any;
    router: any;
    isAlarmRegistered: boolean;
    sCode: STRATEGY_TYPE;
    setAlarmToastVisible: any;
    success?: () => void;
    fail?: (reason?: string) => void;
}) => {
    if (!session || !session.user) {
        router.push("/login");
        return;
    }

    //알림 삭제
    if (isAlarmRegistered) {
        try {
            await axios.delete(
                session?.user?.email
                    ? `/api/auth/strategyAlarm?email=${session.user.email}&code=${sCode}`
                    : ""
            );
            update();
            // await sessionUpdate();
        } catch (e: any) {
            console.log(e);
        }
    } else {
        // 알림 등록
        try {
            // await alarmRegister({
            //   from: "alarm",
            // });

            await axios.post(
                session?.user?.email
                    ? `/api/auth/strategyAlarm?email=${session.user.email}&code=${sCode}`
                    : ""
            );
            success && success();
            await sessionUpdate({ update });
            setAlarmToastVisible(true);
        } catch (e: any) {
            Sentry.captureException(e);
            fail && fail("backend_" + e?.response?.status);
            console.log(e);
        }
    }
};